export default __webpack_public_path__ + "static/media/suvaifusion.ef68c8c3.svg";